import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'time-details',
    templateUrl: 'time-details.component.html',
    styleUrls: ['time-details.component.scss']
})

export class TimeDetailsComponent {

  @Input() customWorkingHour: IWorkingTimeSchema | Array<IBaseCalendarTime>;
  @Input() showClose = true;
  @Input() editedHours = false;
  @Input() isCustom = true;
  @Output() onClose = new EventEmitter();
}
